import haversine from 'haversine-distance'
import { roundDistance } from "./utilities";
import { initGoogleLoader, initGoogleMapFunctions, initGooglePlacesSearch, resetMap, updateMap } from "../helpers/maps";
import { toggleResetButton } from '../helpers/locations';
import { resetRegionFilters } from './location-filters';
import gsap from 'gsap';

export const locationSearch = () => {
    const locationSearchModules = [].slice.call(document.querySelectorAll('.js-location-search-module'));
    
    if ( locationSearchModules.length ) {
        const locationSearchObserver = new IntersectionObserver(initLocationSearch);

        locationSearchModules.forEach(mod => {
            locationSearchObserver.observe(mod);
        });
    }
};

const initLocationSearch = (entries, observer) => {
    entries.forEach(entry => {
        if ( entry.isIntersecting ) {
            const searchElem = entry.target.querySelector('.e__loc-search');
            const geoLocationElem = searchElem.querySelector('.e__loc-search__geo-search');
            const searchInpuContainer = searchElem.querySelector('.e__loc-search__input-container');
            const searchInput = searchElem.querySelector('.e__loc-search__input');
            const searchSubmit = searchElem.querySelector('.e__loc-search__input-submit');
            const searchData = searchElem.querySelector('.e__loc-search__data');
            const revealAll = entry.target.querySelector('.js__llist-reveal-all');
            const locationsContainer = entry.target.querySelector('.js-loc-search-results-container');
            const regionFilterBtnContainer = entry.target.querySelector('.js__show-regions-popup-container');
            const locationsContainerAllItems = locationsContainer.querySelector('.js-loc-search-results-all');
            const locationCards = locationsContainerAllItems.querySelectorAll('.js-loc-card');
            const resultsContainer = locationsContainer.querySelector('.js-loc-search-results-filtered');
            const resultsItems = locationsContainer.querySelector('.js-loc-search-results-filtered-items');
            const locationsContainerMapAllItems = locationsContainer.querySelector('.js-loc-search-map-results-all');
            const resultsMapContainer = locationsContainer.querySelector('.js-loc-search-map-results-filtered');
            const resultsMapItems = locationsContainer.querySelector('.js-loc-search-map-results-filtered-items');
            const map = locationsContainer.querySelector('.js-loc-search-map');

            // if ( igniteJsVars.mapsApiKey !== '' && process.env.NODE_ENV != 'development' ) {
            if ( igniteJsVars.mapsApiKey !== '' ) {
                const googleLoader = initGoogleLoader();
                const googleLibraries = [];
    
                googleLoader.importLibrary('places')
                .then(({Autocomplete}) => {
                    initGooglePlacesSearch(searchInput, searchData, searchSubmit, Autocomplete);
                })
                googleLoader.importLibrary('core')
                .then(({LatLng, LatLngBounds}) => {
                    googleLibraries.push({LatLng, LatLngBounds});
                })
                googleLoader.importLibrary('maps')
                .then(({Map, InfoWindow}) => {
                    googleLibraries.push({Map, InfoWindow});
                })
                googleLoader.importLibrary('marker')
                .then(({AdvancedMarkerElement}) => {
                    googleLibraries.push({AdvancedMarkerElement});

                    initGoogleMapFunctions(googleLibraries, map);
                })
                .catch((e) => {
                    console.log(e);
                });
            } else {
                if ( igniteJsVars.mapsApiKey === '' ) {
                    console.error('No Google Maps API key provided');
                }

                if ( process.env.NODE_ENV === 'development' ) {
                    console.warn('Development environment so not loading Google Maps API');
                }
            }

            // Add event listener for geoLocationElem
            geoLocationElem.addEventListener('click', (event) => {
                event.preventDefault();

                // Add loading class to searchInpuContainer
                searchInpuContainer.classList.add('loading');

                // Set value of searchInput to 'Loading...'
                searchInput.value = 'Loading...';

                //Geolocation API
                navigator.geolocation.getCurrentPosition(
                    (pos) => {
                        // Set lat and lng values on the searchData
                        searchData.dataset.lat = pos.coords.latitude;
                        searchData.dataset.lng = pos.coords.longitude;

                        // Set value of searchInput to 'Your Location'
                        searchInput.value = 'Your Location';

                        // Remove loading class from searchInpuContainer
                        searchInpuContainer.classList.remove('loading');

                        // Dispatch click event on searchSubmit to show results
                        searchSubmit.dispatchEvent(new Event('click'));
                    }, 
                    (error) => {
                        // Remove loading class from searchInpuContainer
                        searchInpuContainer.classList.remove('loading');
                        searchInput.value = '';

                        alert('Failed to access location');
                    }, 
                    {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0,
                    }
                );
            });

            // Add event listener for searchSubmit
            searchSubmit.addEventListener('click' ,(event) => {
                event.preventDefault();
                const activeLocations = [];

                //Check to see if an address has been picked
                if (searchData.dataset.lng > '' && searchData.dataset.lat > '') {
                    // Empty the resultsItems and the map results items
                    resultsItems.innerHTML = '';
                    resultsMapItems.innerHTML = '';

                    //Add distance between users selected address & eachlocation
                    locationCards.forEach(location => {
                        const a = { lat: searchData.dataset.lat, lng: searchData.dataset.lng };
                        const b = { lat: location.dataset.lat, lon: location.dataset.lng };

                        location.dataset.distance = haversine(a, b);
                    });

                    //Now order the locations by that lat lng
                    Array.from(locationCards)
                    .sort(({dataset: {distance: a}}, {dataset: {distance: b}}) => Number(a) - Number(b)) 
                    // remove any items that have a data-region of 4 (Airports)
                    .filter(item => item.dataset.region !== '4')
                    // Number(b) - Number(a) to reverse the sort.
                    .forEach((item, index) => {
                        const location = item.cloneNode(true);

                        // Update the distance badge
                        location.querySelector('.e__content-card__distance-badge').textContent = `${roundDistance(location.dataset.distance)} mi away`;

                        // Only show the first three results or six if on desktop
                        const numberOfResults = window.innerWidth > 767 ? 6 : 3;
                        if ( index >= numberOfResults ) {
                            location.classList.add('!hidden');
                        } else {
                            // Add the location to the activeLocations array
                            activeLocations.push(location.dataset.markerId);
                        }

                        resultsItems.appendChild(location);

                        const mapLocation = location.cloneNode(true);
                        resultsMapItems.appendChild(mapLocation);
                    });

                    // Set the active locations data attribute
                    locationsContainer.dataset.activeLocations = activeLocations.join(',');

                    // Reset the regions filter
                    resetRegionFilters(entry.target);

                    // Update the map center and bounds
                    updateMap(map);

                    // Toggle the reset button
                    toggleResetButton(true, locationsContainer);

                    // Show all the other modules on the page
                    const bodyElem = document.querySelector('#js__body');
                    if ( bodyElem.classList.contains('fixed-search-page') && !bodyElem.classList.contains('show-all-modules') ) {
                        bodyElem.classList.add('show-all-modules');   
                    }

                    // Hide the all locations results container and the map all locations results container
                    locationsContainerAllItems.classList.add('hidden');
                    locationsContainerMapAllItems.classList.add('hidden');

                    // Show the filtered results container and the map filtered results container
                    resultsContainer.classList.remove('hidden');
                    resultsMapContainer.classList.remove('hidden');

                    // Remove hidden class from locationsContainer
                    locationsContainer.classList.remove('hidden');

                    // Hide the regional filter button
                    if ( regionFilterBtnContainer ) {
                        regionFilterBtnContainer.classList.add('hidden');
                    }

                    // Scroll to the results container
					gsap.to(window, {
						duration: 0.6, 
						scrollTo: {
							y: resultsContainer.closest('.js-results-scroll-to-elem'), 
							offsetY: document.querySelector('.header').offsetHeight + 30
						}
					});
                }
            });

            //Add listener to reveal all
            if ( revealAll) {
                revealAll.addEventListener('click', (event) => {
                    event.preventDefault();

                    // Toggle the reset button
                    toggleResetButton(false, locationsContainer, searchElem);

                    // Add triggered class to revealAll
                    event.target.classList.add('triggered');

                    // Show the all locations results container and the map all locations results container
                    locationsContainerAllItems.classList.remove('hidden');
                    locationsContainerMapAllItems.classList.remove('hidden');

                    // Hide the filtered results container and the map filtered results container
                    resultsContainer.classList.add('hidden');
                    resultsMapContainer.classList.add('hidden');

                    // Remove hidden class from locationsContainer
                    locationsContainer.classList.remove('hidden');

                    // Show the regional filter button
                    if ( regionFilterBtnContainer ) {
                        regionFilterBtnContainer.classList.remove('hidden');
                    }
                })
            }

            //Remove this map from the observer, as it's now loaded in
            observer.unobserve(entry.target);
        }
    });
};

export const resetSearchFilters = async (mod) => {
    const locationsContainer = mod.querySelector('.js-loc-search-results-container');
    const locationsContainerAllItems = locationsContainer.querySelector('.js-loc-search-results-all');
    const locationsContainerMapAllItems = locationsContainer.querySelector('.js-loc-search-map-results-all');
    const regions = locationsContainer.querySelectorAll('.js-loc-search-map-region');
    const resultsContainer = locationsContainer.querySelector('.js-loc-search-results-filtered');
    const resultsMapContainer = locationsContainer.querySelector('.js-loc-search-map-results-filtered');
    const searchElem = mod.querySelector('.e__loc-search');

    // Show the all locations results container and the map all locations results container
    locationsContainerAllItems.classList.remove('hidden');
    locationsContainerMapAllItems.classList.remove('hidden');

    // Close all the map regions
    if ( regions ) {
        regions.forEach(region => {
            // Reset all triggers
            const regionTriggers = region.querySelectorAll('.js-loc-search-map-region-trigger');
            if ( regionTriggers ) {
                regionTriggers.forEach(trigger => {
                    trigger.classList.remove('active');

                    const arrow = trigger.querySelector('svg');
                    arrow.classList.remove('-scale-y-100');
                });
            }

            // Close all regions content elems
            const regionsContent = region.querySelectorAll('.js-loc-search-map-region-content');
            if ( regionsContent ) {
                regionsContent.forEach(region => {
                    region.classList.add('hidden');
                });
            }
        });
    }

    // Hide the filtered results container and the map filtered results container
    resultsContainer.classList.add('hidden');
    resultsMapContainer.classList.add('hidden');

    // Show the regional filter button
    const regionFilterBtnContainer = locationsContainer.querySelector('.js__show-regions-popup-container');
    if ( regionFilterBtnContainer ) {
        regionFilterBtnContainer.classList.remove('hidden');
    }

    // Reset the active locations data attribute
    locationsContainer.dataset.activeLocations = '';

    // Reset the search elem values
    const searchInput = searchElem.querySelector('.e__loc-search__input');
    const searchData = searchElem.querySelector('.e__loc-search__data');

    searchInput.value = '';
    searchData.dataset.lat = '';
    searchData.dataset.lng = '';
};